import { render, staticRenderFns } from "./NotificationDialog.vue?vue&type=template&id=6538f037&scoped=true&"
import script from "./NotificationDialog.vue?vue&type=script&lang=ts&"
export * from "./NotificationDialog.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationDialog.vue?vue&type=style&index=0&id=6538f037&prod&lang=less&"
import style1 from "./NotificationDialog.vue?vue&type=style&index=1&id=6538f037&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6538f037",
  null
  
)

export default component.exports